import React from 'react'
import { motion } from 'framer-motion'

import { Loader } from '@/shared/components/ui/loader'

export function FullscreenLoading() {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className='fixed flex h-full w-full items-center justify-center text-xl font-semibold'
		>
			<Loader />
		</motion.div>
	)
}
